import Vue from 'vue'
import Vuex from 'vuex'
import {getRequest} from "../utils/api";
import LoginDialog from '../components/loginDialog';
import RegisterDialog from '../components/RegisterDialog';


const LoginDialogConstructor = Vue.extend(LoginDialog); //注册实例

const RegisterDialogConstructor = Vue.extend(RegisterDialog); //注册实例

export const myLoginDialog = (options,methods = {}) => {
  // new 一个实例
  const instance = new LoginDialogConstructor(
    {
    data: options,// 存放数据
    methods //存放方法
  }
  ).$mount();//将实例进行挂载
  document.body.appendChild(instance.$el);
}


export const myRegisterDialog = (options,methods = {}) => {
    // new 一个实例
    const instance = new RegisterDialogConstructor(
      {
      data: options,// 存放数据
      methods //存放方法
    }
    ).$mount();//将实例进行挂载
    document.body.appendChild(instance.$el);
  }

Vue.use(Vuex)
const now = new Date();
const store = new Vuex.Store({
    state: {
        routes: [],
        sessions: {},
        hrs: [],
        editableTabs:[],
        currentSession: null,
       // currentAdmin: JSON.parse(window.sessionStorage.getItem("user")),
        filterKey: '',
        stomp: null,
        isDot: {}
    },
    mutations: {
        INIT_CURRENTHR(state, hr) {
            state.currentAdmin = hr;
        },
        initRoutes(state, data) {   
            state.routes = data;
        },
        initEditableTabs(state,data){
            state.editableTabs=data
        }
    },
    actions: {
        initData(context) {
            context.commit('INIT_DATA')
            getRequest("/admin/info").then(resp => {
                if (resp) {
                    context.commit('INIT_HR', resp.data);
                }
            })
        }
    }
})
export default store;